module.exports = __webpack_public_path__ + "img/roadramble.4c9b8d4d.svg";